import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function BootModal({ title, children, size, footer, show, onHide, ...rest }) {
  return (
    <Modal {...rest} show={show} onHide={onHide} size={size} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="modal-header">
        <h5 className="modal-title tx-medium" id="exampleModalLabel6">
          {title}
        </h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onHide}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <Modal.Body>{children}</Modal.Body>
      {footer || (
        <Modal.Footer>
          <Button onClick={onHide}>Close</Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default BootModal;
